/**
 * new component icon map for material symbols
 * @see {@link https://fonts.google.com/icons}
 */
export const ComponentIconMap: Record<string, string> = {
  'array-gallery': 'collections',
  'circular-progress': 'donut_large',
  'data-list': 'list_alt',
  'data-table': 'table_view',
  'datetime-picker': 'event',
  'field-rating': 'star_rate',
  'hidden-field': 'visibility_off',
  'image-upload': 'image_arrow_up',
  'linear-progress': 'linear_scale',
  'login-form': 'login',
  'multi-location': 'location_on',
  'rich-text': 'format_quote',
  'shopping-cart': 'shopping_cart',
  'text-field': 'text_fields',
  'vertical-menu': 'menu_open',
  accordion: 'unfold_more',
  audio: 'audiotrack',
  bar: 'bar_chart',
  button: 'smart_button',
  card: 'cards',
  checkbox: 'check_box',
  comment: 'comment',
  divider: 'horizontal_rule',
  fab: 'add_circle',
  file: 'attach_file_add',
  form: 'format_list_bulleted',
  gallery: 'photo_library',
  icon: 'insert_emoticon',
  image: 'image',
  list: 'list',
  map: 'map',
  menu: 'menu',
  pie: 'pie_chart',
  rating: 'star',
  section: 'view_agenda',
  selection: 'checklist_rtl',
  slider: 'tune',
  switch: 'toggle_on',
  tabs: 'tab',
  text: 'format_size',
  video: 'videocam',
  timeline: 'view_timeline',
  calendar: 'calendar_month',
  prompt: 'terminal',
  quantity: 'exposure_plus_1',
  pricing: 'price_change',
  newsletter: 'mail',
  alert: 'emergency_home',
  'icon-picker': 'add_reaction',
  'phone-input': 'contact_phone',
  header: 'web_asset',
  footer: 'page_footer',
}

export const DesignBlocksIconMap: Record<string, string> = {
  'basic-50-50': 'splitscreen_landscape',
  'basic-70-30': 'dock_to_right',
  'basic-30-70': 'dock_to_left',
  'basic-75-25': 'dock_to_right',
  'basic-25-75': 'dock_to_left',
  'basic-33-33-33': 'width_normal',
  'basic-25-25-25-25': 'calendar_view_week',
  'basic-30-70-reverse': 'width_wide',
  'basic-75-25-reverse': 'width_wide',
  'complex-100-50-50': 'view_quilt',
  'complex-100-33-33-33': 'view_quilt',
  'complex-100-60-40': 'view_quilt',
  'complex-100-40-60': 'view_quilt',
  'complex-100-25-75': 'view_quilt',
  'complex-100-75-25': 'view_quilt',
  'hero-1': 'clarify',
  'hero-2': 'clarify',
  'hero-3': 'clarify',
  'hero-4': 'clarify',
  'hero-5': 'clarify',
  'hero-6': 'clarify',
  'hero-7': 'clarify',
  'hero-8': 'clarify',
  'hero-9': 'clarify',
  'hero-10': 'clarify',
  'hero-11': 'clarify',
  'hero-12': 'clarify',
  'hero-13': 'clarify',
  'cta-1': 'call_to_action',
  'cta-2': 'call_to_action',
  'cta-3': 'call_to_action',
  'cta-4': 'call_to_action',
  'cta-5': 'call_to_action',
  'cta-6': 'call_to_action',
  'cta-7': 'call_to_action',
  'cta-8': 'call_to_action',
  'profile-1': 'contacts',
  'profile-2': 'contacts',
  contact1: 'contact_mail',
  contact2: 'contact_mail',
  contact3: 'contact_mail',
  contact4: 'contact_mail',
  contact5: 'contact_mail',
  contact6: 'contact_mail',
  team1: 'groups',
  team2: 'groups',
  team3: 'groups',
  team4: 'groups',
  team5: 'groups',
  team6: 'groups',
  '2-button': 'smart_button',
  dashboard1: 'space_dashboard',
  dashboard2: 'space_dashboard',
  service1: 'handyman',
  service2: 'handyman',
}

export const PagesIconMap: Record<string, string> = {
  'page-dashboard1': 'space_dashboard',
}
